import { Box, CircularProgress, alpha, circularProgressClasses } from "@mui/material";
import React from "react";

interface CircularLoadingProps {
    size?: "sm" | "lg";
}

export const CircularLoading = ({ size = "sm" }: CircularLoadingProps) => {
    return (
        <Box position="relative">
            <CircularProgress
                variant="determinate"
                sx={(theme) => ({
                    color: alpha(theme.palette.primary.main, 0.4),
                })}
                size={size === "lg" ? 80 : 40}
                value={100}
            />
            <CircularProgress
                disableShrink
                sx={{
                    animationDuration: "800ms",
                    position: "absolute",
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: "round",
                    },
                }}
                size={size === "lg" ? 80 : 40}
            />
        </Box>
    );
};
